import React from "react";

import { HeaderBreadcrumb } from "../../../common/ui/layout/header/header-breadcrumb/HeaderBreadcrumb";
import { PageHeader } from "../../../common/ui/layout/header/PageHeader";
import { adminRoutes } from "../../AdminRoutes";
import { AirlineListing } from "./list/AirlineListing";
import { AirlineProvider } from "./list/context/AirlineProvider";

export const AirlineListingDashboard: React.FC = () => {
    return (
        <AirlineProvider>
            <PageHeader>
                <HeaderBreadcrumb routes={adminRoutes} />
            </PageHeader>
            <AirlineListing />
        </AirlineProvider>
    );
};
